export const quartilesRatings = {
  "quartilesRatings.rating.set": "quartilesRatings.rating.set",
  "quartilesRatings.version.set": "quartilesRatings.version.set",
  "quartilesRatings.version.delete": "quartilesRatings.version.delete",
  "quartilesRatings.list.delete": "quartilesRatings.list.delete",
  "quartilesRatings.versions.get": "quartilesRatings.versions.get",
  "quartilesRatings.ratings.get": "quartilesRatings.ratings.get",
  "quartilesRatings.ratingsListName.get":
    "quartilesRatings.ratingsListName.get",
  "quartilesRatings.ratingData.get": "quartilesRatings.ratingData.get",
  "quartilesRatings.ratingDataByLine.get":
    "quartilesRatings.ratingDataByLine.get",
  "quartilesRatings.detailingMainIndicator.get":
    "quartilesRatings.detailingMainIndicator.get",
  "quartilesRatings.allowedMonthsForDealer.get":
    "quartilesRatings.allowedMonthsForDealer.get",
  "quartilesRatings.fullReports.get": "quartilesRatings.fullReports.get",
  "quartilesRatings.reports.get": "quartilesRatings.reports.get",
  "quartilesRatings.beautifulReports.get":
    "quartilesRatings.beautifulReports.get",
  "quartilesRatings.reportDetailingMainIndicator.get":
    "quartilesRatings.reportDetailingMainIndicator.get",
} as const;
